// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.o-maintenance-admin-status {
  color: #504F4F;
  margin: 0 0 1.5rem;
}
.o-maintenance-admin-status strong.is-on {
  color: #9e3d3d;
}

.o-maintenance-admin__loading {
  display: flex;
  justify-content: center;
  padding: 3rem 0;
  color: #504F4F;
  font-size: 28px;
}`, "",{"version":3,"sources":["webpack://./src/app/core/pages/maintenance-admin/maintenance-admin-page.component.scss","webpack://./src/assets/styles/quarks/_colors.scss"],"names":[],"mappings":"AAGA;EACC,cCDa;EDEb,kBAAA;AAFD;AAIC;EACC,cCOO;ADTT;;AAMA;EACC,aAAA;EACA,uBAAA;EACA,eAAA;EACA,cCba;EDcb,eAAA;AAHD","sourcesContent":["@import '../../../../assets/styles/quarks/colors';\n@import '../../../../assets/styles/quarks/variables';\n\n.o-maintenance-admin-status {\n\tcolor: $medium-gray;\n\tmargin: 0 0 $spacer-large;\n\n\tstrong.is-on {\n\t\tcolor: $danger;\n\t}\n}\n\n.o-maintenance-admin__loading {\n\tdisplay: flex;\n\tjustify-content: center;\n\tpadding: $spacer-2x-large 0;\n\tcolor: $medium-gray;\n\tfont-size: 28px;\n}\n","$black: #000000;\n$darker-gray: #242424;\n$dark-gray: #333333;\n$medium-gray: #504F4F;\n$search-gray: #878787;\n$gray: #707070;\n$light-gray: #BBBBBB;\n$lighter-gray: #E3E3E3;\n$white: #FFFFFF;\n\n$primary: #D4B643;\n$primary-dark: #9E6E3D;\n\n$success: #3A754E;\n$warning: #F08A24;\n$danger: #9e3d3d;\n$danger-light: #ff6565;\n\n$input-background: #3D3D3D;\n$light-input-background: #414141;\n"],"sourceRoot":""}]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___.toString();
